import { useEffect, useMemo, useState } from "react";
import { base64ToFile } from "@/utils/index";
import { handleS3UploadFile } from "@/utils/upload";
import { personalSignAgreemnet, getKycSignAgreemnetApi } from "@/api/kyc";
import { getS3UrlApi } from "@/api/common";
import { useAppSelector } from "@/state/hooks";

export const useHooks = ({ setStep }) => {
  const kycInfo = useAppSelector((state) => state.kyc.kycInfo);
  const [stage, setStage] = useState(null);
  const [layer, setLayer] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false); // 上传loading
  const [agreementDisabled, setAgreementDisabled] = useState(true);
  const [checkedAgreement, setCheckedAgreement] = useState(false);
  const [checkedSign, setCheckedSign] = useState(false);
  const [isDrew, setIsDrew] = useState(false);
  const [signImgUrl, setSignImgUrl] = useState("");

  const canSubmit = useMemo(() => {
    if (checkedSign && checkedAgreement && isDrew) {
      return true;
    }
    return false;
  }, [checkedSign, checkedAgreement, isDrew]);

  const getKycSignAgreemnet = async () => {
    const res = await getKycSignAgreemnetApi();
    if (res.code === 0) {
      const path = res?.data?.["documents"]?.[0]?.document_path;
      const _res = await getS3UrlApi({ file_path: path });
      if (_res?.code === 0) {
        setSignImgUrl(_res?.data?.url);
        setIsDrew(true);
        setCheckedSign(true);
        setAgreementDisabled(false);
        setCheckedAgreement(true);
      }
    }
  };

  useEffect(() => {
    if (kycInfo?.length > 0) {
      const step3 = kycInfo[2];
      if (step3?.status === "PENDING") {
        getKycSignAgreemnet();
      }
    }
  }, [kycInfo]);

  const handleSubmit = () => {
    if (signImgUrl) {
      setStep(4);
    } else {
      setUploadLoading(true);
      if (stage) {
        const base64Image = layer.getCanvas().toDataURL("image/png");
        if (base64Image) {
          base64ToFile(base64Image, "sign")
            .then(async (file) => {
              setUploadLoading(true);
              const uploadRes = await handleS3UploadFile({
                prefix: "personal_agreement",
                file_type: "png",
                file,
              });
              if (uploadRes.status !== "error") {
                setUploadLoading(false);
                const { filePath } = uploadRes;
                console.log("[[filePath]]", filePath);
                const params = {
                  documents: [
                    {
                      document_type_comment: "personal_agreement",
                      document_path: filePath,
                      document_type: "png",
                    },
                  ],
                };
                console.log("[[params]]", params);
                const res = await personalSignAgreemnet(params);
                if (res.code === 0) {
                  setUploadLoading(false);
                  setStep(4);
                }
              } else {
                setUploadLoading(false);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
              setUploadLoading(false);
            });
        }
      }
    }
  };

  return {
    stage,
    setStage,
    layer,
    setLayer,
    handleSubmit,
    uploadLoading,
    setUploadLoading,
    agreementDisabled,
    setAgreementDisabled,
    checkedAgreement,
    setCheckedAgreement,
    checkedSign,
    setCheckedSign,
    canSubmit,
    setIsDrew,
    signImgUrl,
    setSignImgUrl,
  };
};
